import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, Fragment, useState } from 'react';
import { exposeTestId } from '../../config';
import { CrosstabState } from '../../store/birdElement/crosstabState';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import GestureHelper from '@sas-dvr/ltjs-commons/gestures/GestureHelper';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import { createUniqueId } from '../utils/createUniqueId';
import { selectAccessibilityLabelState, selectLayoutState, selectMessageState, } from '../../store/selectors';
import { useMessageToast } from '../utils/messageToast';
import { MessageState } from '../../store/message/MessageState';
//css
import cn from './BirdCrosstab.css.json';
import './BirdCrosstab.css';
export const BirdCrosstabBase = function (props) {
    const [contentId] = useState(createUniqueId);
    useLayoutEffect(() => {
        props.actions.update(props.id, { contentId });
        return function () {
            props.actions.update(props.id, { contentId: undefined });
        };
    }, [props.actions, props.id, contentId]);
    const contentRef = useRef(null);
    const messageToast = useMessageToast({
        message: props.message,
        referenceElementRef: contentRef,
        onDismiss: () => props.messageActions.set(props.id, undefined),
    });
    const style = {};
    if (props.minWidth) {
        style.minWidth = props.minWidth + 'px';
    }
    if (props.minHeight) {
        style.minHeight = props.minHeight + 'px';
    }
    return (_jsxs(Fragment, { children: [_jsx("div", { id: contentId, "data-testid": exposeTestId() ? contentId : null, className: cn.crosstab, tabIndex: 0, ref: contentRef, "aria-label": props.accessibilityLabel, style: Object.assign(Object.assign({}, style), { display: 'flex', flexShrink: 1, width: '100%', height: '100%' }), onContextMenu: (e) => {
                    const position = GestureHelper.getMousePosition(e.nativeEvent, e.currentTarget, true);
                    props.actions.setGraphPosition(position);
                } }), messageToast] }));
};
export const BirdCrosstab = connect((state, props) => {
    const constraints = selectLayoutState(state, props.id).constraints;
    return {
        minWidth: constraints === null || constraints === void 0 ? void 0 : constraints.minWidth,
        minHeight: constraints === null || constraints === void 0 ? void 0 : constraints.minHeight,
        accessibilityLabel: selectAccessibilityLabelState(state, props.id),
        message: selectMessageState(state, props.id),
    };
}, (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setGraphPosition: ReportContextMenuState.actions.setGraphPosition }, CrosstabState.actions), dispatch),
    messageActions: bindActionCreators(MessageState.actions, dispatch),
}))(BirdCrosstabBase);
